import { formData, formInfo } from '../constants/actions'

const initialState = {
  members: [],
  defaultQuestions: [],
  defaultTeamQuestions: [],
  event: {},
  form: {},
  memberTypes: [],
  organisation: [],
  organisationsInfo: [],
  products: [],
  questions: [],
  messages: [],
  subEvents: [],
  addOn: {},
  discounts: [],
  team: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case formInfo.SET_FORM_INFO: {
      return {
        ...state,
        ...(action.payload || {}),
        messages: action.payload.messaging,
        defaultQuestions: action.payload.defaultQuestions.filter(q => !q.isTeamQuestion),
        defaultTeamQuestions: action.payload.defaultQuestions
          .filter(q => q.isTeamQuestion)
          .map(q => ({
            ...q,
            dependentQuestions: [
              {
                primaryQuestionAnswer: 'Register A Team',
                primaryQuestionId: 'registerOrJoinATeam',
                primaryQuestionType: 'Toggle',
              },
              {
                primaryQuestionAnswer: 'Create New',
                primaryQuestionId: 'newOrExistingTeam',
                primaryQuestionType: 'Toggle',
              },
            ],
          })),
      }
    }
    case formData.RESET_FORM: {
      return { ...initialState }
    }
    default:
      return state
  }
}
